var o = Object.defineProperty;
var i = (r, e, t) => e in r ? o(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var s = (r, e, t) => i(r, typeof e != "symbol" ? e + "" : e, t);
import { HttpClient as p, httpClient as a } from "../../httpClient.js";
class u extends p {
  constructor() {
    super(...arguments);
    s(this, "baseEndpoint", "/users/current-user");
  }
  async getBillingInfo() {
    return a.get(`${this.baseEndpoint}/billing-info`);
  }
  async updateCard(t) {
    return a.post(`${this.baseEndpoint}/cards`, { token: t });
  }
  async deleteCard(t) {
    return a.delete(`${this.baseEndpoint}/cards/${t}`);
  }
  async updateSubscriptionDay(t) {
    return a.put(`${this.baseEndpoint}/subscription`, { billingDay: t });
  }
  async updatePersonalInfo(t, n) {
    return a.put(`/users/${t}`, n);
  }
  async uploadAvatar(t) {
    const n = new FormData();
    return n.append("avatar", t), a.post("/avatar", n);
  }
  async uploadFile(t) {
    const n = new FormData();
    return n.append("file", t), a.post("/files", n);
  }
}
const c = new u();
export {
  c as default
};
